import { Box, Text, ListItemSelect, Image } from '@wix/design-system';
import React, { useContext } from 'react';
import { RicosContext } from 'ricos-context';
import { getScaleImageSrc } from 'wix-rich-content-common/libs/imageUtils';
import { convertDuration } from '../convertDuration.js';
import { INSERT_VERTICAL_EMBED_MODAL_ITEM, INSERT_VERTICAL_EMBED_MODAL_ITEM_IMAGE } from '../dataHooks.js';
import 'lodash';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const ItemsList = ({
  items,
  onClick,
  selectedItem,
  contentType
}) => {
  const { t, environment } = useContext(RicosContext);
  if (items.length === 0) {
    return /* @__PURE__ */ React.createElement(Box, { direction: "vertical", margin: "SP4", gap: "SP2", textAlign: "center" }, /* @__PURE__ */ React.createElement(Text, { size: "medium", secondary: true }, t(`Embed_Vertical_${contentType}_EmptyState_NoItems_Title`)), /* @__PURE__ */ React.createElement(Text, { size: "small", secondary: true }, t(`Embed_Vertical_${contentType}_EmptyState_NoItems_Description`)));
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, items.map((item) => {
    return /* @__PURE__ */ React.createElement(
      ListItemSelect,
      {
        key: item.id,
        dataHook: INSERT_VERTICAL_EMBED_MODAL_ITEM,
        title: item.name,
        selected: (selectedItem == null ? void 0 : selectedItem.id) === item.id,
        onClick: () => onClick(item),
        ellipsis: true,
        prefix: /* @__PURE__ */ React.createElement(Box, { width: "50px", height: "50px", margin: "6px 6px 6px 0" }, /* @__PURE__ */ React.createElement(
          Image,
          __spreadValues({
            src: item.imageSrc ? getScaleImageSrc(item.imageSrc, 50, 50) : void 0,
            dataHook: INSERT_VERTICAL_EMBED_MODAL_ITEM_IMAGE
          }, environment === "liveSite" ? { borderRadius: "0" } : {})
        )),
        subtitle: contentType === "booking" ? convertDuration(item.durations, t) || void 0 : contentType === "event" ? `${item.scheduling} | ${item.location}` : void 0
      }
    );
  }));
};

export { ItemsList };
//# sourceMappingURL=ItemsList.js.map
